module.exports = __webpack_public_path__ + "static/corner_lobster-5bdb0014e3e4737134f491824371141e.png";